import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";

//Import tags
import Skeleton from "react-loading-skeleton";

// Import API
import FetchData from '../../../api/Api';

export default function Categories() {

    const [data, setData] = useState(null);

    //import locales
    const { locale } = useParams();

    // Fetch categories
    useEffect(() => {
        if (data === null) {
            const fetchCategoriesData = async () => {
                try {
                const fetchDataInstance = new FetchData();
                await fetchDataInstance.initHeaders(locale.length > 0 ? locale : 'ka' );
                const result = await fetchDataInstance.get(`/api/categories/home`, true);
                setData(result);
                } catch (error) {
                console.error("Failed to fetch data:", error.message);
                }
            };

            setTimeout(function() {
                fetchCategoriesData();
            }, 100)
            
        }
    }, [data, locale]);

    useEffect(()=> {
        setData(null);
    }, [locale])

    return (
        <div className="grid grid-cols-12 gap-3 lg:gap-5">
            {
                data === null ?
                    <>
                        {
                            [1, 2, 3, 4, 5, 6, 7, 8].map((items) => (
                                <div className="group border border-gray-150 col-span-6 lg:col-span-4 xl:col-span-3 p-5 text-center shadow-lg hover:shadow-none rounded-xl duration-500">
                                    <div className="upper relative mt-[-2px] rounded-2xl w-fit mx-auto before:content-[''] before:bg-[var(--orange)] before:w-[50px] before:h-[1px] before:absolute before:left-0 before:top-0 before:-ms-[50px] before:mt-6 after:content-[''] after:bg-[var(--orange)] after:w-[50px] after:h-[1px] after:absolute after:right-0 after:top-0 after:-me-[50px] after:mt-6 z-10">
                                        <Skeleton baseColor="#f2f2f7" height={40} highlightColor="#fff" borderRadius={12} width={150} />
                                    </div>
                                    <Skeleton baseColor="#f2f2f7" highlightColor="#fff" height={343} borderRadius={12} />
                                </div>
                            ))
                            
                        }
                    
                    </>
                :
                (
                    typeof data === 'object' && data != null ? 
                    data.data.slice(0, 8).map((item) => {
                        return(
                            <div key={item.id} className="group border border-gray-150 col-span-6 lg:col-span-4 xl:col-span-3 p-5 text-center shadow-lg hover:shadow-none rounded-xl duration-500 overflow-hidden">
                                <Link to={`/${locale}/products/${item.slug || ""}`}>
                                    <div className="upper relative bg-gray-200 rounded-2xl text-xs md:text-md 2xl:text-xll w-fit px-4 py-1 pt-2 mx-auto before:content-[''] before:bg-[var(--orange)] before:w-[50px] before:h-[1px] before:absolute before:left-0 before:top-[50%] before:-ms-[50px] before:mt-[-1px] after:content-[''] after:bg-[var(--orange)] after:w-[50px] after:h-[1px] after:absolute after:right-0 after:top-[50%] after:-me-[50px] after:mt-[-1px] z-10">
                                        {item.translations?.[0]?.name || "No title"}
                                    </div>
                                    <img 
                                        className="w-full transform transition-transform duration-500 group-hover:scale-105" 
                                        alt={item.translations?.[0]?.name || "No title"}
                                        src={`${process.env.REACT_APP_API_URL}/storage/uploads/categories/thumbs/large_${item.image}`}
                                    />
                                </Link>
                            </div>
                        );
                    })
                    :
                    ''
                )
                
            }
            
        </div>
        
    );
}